import { Button, ButtonProps, Popover, SizableText, YStack, isWeb } from '@my/ui'
import { MoreVertical } from '@tamagui/lucide-icons'
import { limitToRange } from 'app/lib/limit-to-range'

export interface GroupEventOption extends ButtonProps {
  label: string
  description: string
  color?: string
}

export interface GroupEventOptionsProps {
  open: boolean
  setOpen: (open: boolean) => void
  options?: GroupEventOption[]
}

export const GroupEventOptions = (props: GroupEventOptionsProps) => {
  if (!props.options) {
    return null
  }

  const itemHeight = 10 // In % of screen height
  const snapPoint = limitToRange(
    props.options.length * itemHeight + (isWeb ? 25 : 0),
    isWeb ? 40 : 25,
    80
  )
  return (
    <Popover
      placement="bottom-start"
      isBouncy
      anchor={
        <Button
          onPress={() => props.setOpen(true)}
          aria-label='Open post options'
          size="$3"
          px="$2"
          plain
          icon={<MoreVertical size={24} />}
        />
      }
      sheetProps={{
        snapPoints: [snapPoint],
      }}
      open={props.open}
      onOpenChange={props.setOpen}
    >
      <YStack
        gap="$3.5"
        alignItems="center"
        jc="center"
        py="$3.5"
        $gtSm={{
          px: '$2',
          py: '$2.5',
          gap: '$2.5',
        }}
      >
        {props.options.map((option, index) => (
          <Button
            key={`actionMenu-${index}`}
            aria-label={option.description}
            size="$5"
            plain
            onPress={option.onPress}
            icon={option.icon}
            loading={option.loading}
            alignItems="center"
            w="100%"
            $gtSm={{
              size: '$3',
              jc: 'flex-start',
            }}
          >
            <SizableText
              color={option?.color}
              size="$5"
              fow="500"
              $gtSm={{
                size: '$3',
                fow: '500',
              }}
            >
              {option.label}
            </SizableText>
          </Button>
        ))}
      </YStack>
    </Popover>
  )
}
